var React = require('react');

function TimelineBgShape (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path 2"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"Path-2","fill":"#EAC059","points":"0.627265943 4.94097026 226.022281 198.291952 226.022281 458.218838 1430.83836 458.218838 1443.67529 496 1610 496 1610 0.675202386 0.627265943 0.675202386"}))]);
}

TimelineBgShape.defaultProps = {"viewBox":"0 0 1610 496","version":"1.1"};

module.exports = TimelineBgShape;

TimelineBgShape.default = TimelineBgShape;
